import socket from "@/socket.js";
import { friendServer, feedServer } from "@/http"

export default {
    bindEvents(context) {
        socket.on('user:connect', (user) => {
            context.commit('updateUserStatus', user);
        });
        socket.on('user:disconnect', (user) => {
            context.commit('updateUserStatus', user)
        });
        socket.on('user:status', (user) => {
            context.commit('fetchUserStatus', user)
        });
    },
    async sendFriendRequest(_, payload) {
        const response = await friendServer.post(`/api/friends/${payload.userId}/request`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (response.status !== 201) {
            throw new Error(response.message);
        }
    },
    async getFriendRequests(context) {
        const response = await friendServer.get(`/api/friends/requests`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });

        if (response.status !== 200) {
            throw new Error(response.message);
        }

        context.commit('setFriendRequests', response.data);
    },
    async acceptFriendRequest(_, payload) {
        const response = await friendServer.post(`/api/friends/${payload.userId}/accept`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (response.status !== 200) {
            throw new Error(response.message);
        }
    },
    async getFriends() {
        const response = await feedServer.get(`/user/friend`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });

        if (response.status !== 200) {
            throw new Error(response.message);
        }

        return response.data;
    },
    async getFriendStatus(context, payload) {
        context.commit('getFriendStatus', payload);
    }
}
